/**
 * Checkout Overlay Customization
 *
 * Overrides WooCommerce's BlockUI implementation to provide a custom loading overlay
 * during checkout form submission.
 */
jQuery(function($) {
	// Store original method
	var originalBlock = $.fn.block;

	// Override with custom styling but only for full-page overlay
	$.fn.block = function(opts) {
		// Store reference to the current element being blocked
		var $el = $(this);

		// Check if this is the full checkout form or body being blocked
		// Full-page blocks are typically applied to larger containers like form.checkout or body
		if ($el.is('form.checkout') || $el.is('body') || $el.is('.woocommerce-checkout') ||
			$el.width() > $(window).width() * 0.8) { // Check if element covers most of screen width

			// Apply custom styling only to full-page overlay
			opts = opts || {};
			opts.message = '<div class="sc-checkout-overlay"><span class="sc-checkout-overlay__loader">' + window.stellarCommerce.throbber + '</span><span class="sc-checkout-overlay__message">We\'re processing your order!</span></div>';
			opts.overlayCSS = $.extend({}, opts.overlayCSS, {
				backgroundColor: '#FFF',
				opacity: 0.9,
				backgroundSize: '50px 50px',
				cursor: 'wait'
			});
		}

		// Call original block method
		return originalBlock.call(this, opts);
	};
});
